import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
// import "./registerServiceWorker";
import vueToasted from "vue-toasted";
import i18n from "@/lib/vue-i18n/index";
import ncalayer from "@/lib/ncalayer/index";
// import VueApexCharts from "vue-apexcharts";
import { HalfCircleSpinner } from "epic-spinners";
import RegisterInput from "@/components/register/Input";
import RegisterSelect from "@/components/register/SelectInput";
import FileInput from "@/components/register/FileInput";
import RegisterTitle from "@/components/register/Title";
import ExpSelect from "@/components/register_kyc/inputs/select.vue";
import { HelpersPlugin } from "./helpers/plugin.index";
// Vue.component("apexchart", VueApexCharts);
Vue.component("spinner", HalfCircleSpinner);
Vue.component("file-input", FileInput);
Vue.component("register-title", RegisterTitle);
Vue.component("register-select", RegisterSelect);
Vue.component("register-input", RegisterInput);
Vue.component("exp-select", ExpSelect);
import VModal from "vue-js-modal";

Vue.use(VModal, { dialog: true });
Vue.use(HelpersPlugin);
//
// Vue.use(DatePicker);
// Vue.use(Menu);
// import "ant-design-vue/dist/antd.css";
import "@/assets/styles/flexboxgrid.css";

import IdleVue from "idle-vue";
const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  // startAtIdle: false,
  events: ["keydown", "mousedown", "click"], // ['mousemove', 'keydown', 'mousedown', 'touchstart']
  idleTime: 10 * 60 * 1000 //Idle time (Время простоя, 10мин)
});

Vue.config.productionTip = false;
Vue.use(ncalayer);
Vue.use(vueToasted, {
  theme: "toasted-primary",
  position: "bottom-right",
  duration: 3000
});

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(far);
library.add(fas);
library.add(fab);
Vue.component("icon-fa", FontAwesomeIcon);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
